<template>
  <div class="step-information">
    <div
      class="fields"
      v-for="(group, key) in sharedFieldsChunked"
      :key="key"
    >
      <information-field
        v-for="field in group"
        :key="field.name"
        :type="field.type"
        :name="field.name"
        :label="field.label"
        :tip="field.tip"
        :options="field.values"
        :disabled="disabledFields.includes(field.name)"
        :required="!field.optional"
        v-model="form[field.name]"
      />
    </div>

    <div
      v-for="group in exclusiveFieldsGroupedChunked"
      :key="group.name"
    >
      <div
        class="fields"
        v-for="(chunk, key) in group.fields"
        :key="key"
      >
        <information-field
          v-for="field in chunk"
          :key="field.name"
          :type="field.type"
          :name="field.name"
          :label="field.label"
          :tip="field.tip"
          :options="field.values"
          :disabled="disabledFields.includes(field.name)"
          :required="!field.optional"
          v-model="form[field.name]"
        />
      </div>
    </div>

    <div class="bg-primary-100 border border-primary-400 text-primary-700 px-4 py-3 rounded relative mb-4 bg-opacity-25" role="alert" v-if="exclusiveFieldsGroupedChunked.length === 0">
          <span class="block sm:inline">
            Essa consulta não possui nenhuma opção para selecionar, clique em avançar para continuar.
          </span>
      <span class="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
    </div>
  </div>
</template>

<script>
import { chunk, flatMap } from 'lodash';
import newQueryFormFields from '@/template/mixins/newQueryFormFields';
import InformationField from '@/template/components/new-query/step-information/InformationField.vue';

export default {
  name: 'StepInformation',

  props: {
    tag: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  data() {
    return {
      disabledFields: [],
    };
  },

  methods: {
    /**
     * Load disabled fields.
     */
    loadDisabledFields() {
      const exclusiveFields = flatMap(this.exclusiveFieldsGrouped, (group) => group.fields);

      this.disabledFields = [...this.sharedFields, ...exclusiveFields]
        .filter((field) => field.oneOf)
        .filter((field) => {
          const disabled = field.oneOf.filter((rule) => {
            const fieldValue = this.form[rule.field];
            if (!fieldValue) {
              return false;
            }

            return !rule.values || rule.values.some((value) => value === fieldValue || parseInt(value, 10) === parseInt(fieldValue, 10));
          }).length === 0;

          return disabled;
        })
        .map((field) => field.name);
    },
  },

  computed: {
    /**
     * The shared fields chunked in
     * group of three.
     *
     * @returns {Array}
     */
    sharedFieldsChunked() {
      return chunk(this.sharedFields, 3);
    },

    /**
     * The exclusives fields grouped and chunked in
     * group of three.
     *
     * @returns {Array}
     */
    exclusiveFieldsGroupedChunked() {
      return this.exclusiveFieldsGrouped
        .map((group) => ({
          ...group,
          fields: chunk(group.fields, 3),
        }));
    },
  },

  mounted() {
    this.loadDisabledFields();
  },

  watch: {
    form: {
      deep: true,
      handler() {
        this.loadDisabledFields();
      },
    },

    disabledFields(newDisabledFields) {
      newDisabledFields.forEach((field) => {
        delete this.form[field];
      });
    },
  },

  mixins: [
    newQueryFormFields,
  ],

  components: {
    InformationField,
  },
};
</script>

<style lang="scss" scoped>
  .step-information {
    width: 100%;

    @media (min-width: 768px) {
      @apply grid;
      @apply grid-cols-1;
      @apply gap-4;
    }

    > .fields,
    > .group-fields > .fields {
      width: 100%;

      @media (min-width: 768px) {
        @apply grid;
        @apply gap-4;
        grid-auto-columns: 1fr;
        grid-auto-flow: dense;
        grid-template-columns: repeat( auto-fit, minmax(250px, 1fr) );
      }
    }
  }
</style>
